export default __webpack_public_path__ + "static/media/cover-9.eb5f783d.webp";